export default __webpack_public_path__ + "static/media/mov.f911fe7b.svg";